const createActionName = require('../util').createActionName('user');

export const UI_RESIZE = createActionName('UI_RESIZE');

export const uiResize = (width) => ({
  type: UI_RESIZE,
  width: width,
});
